import { Component } from "react";
import { extract } from "@parksandresorts/core";
import PropTypes from "prop-types";
import UpgradeProduct from "components/block-elements/upgrade-product/upgrade-product";
//import AdditionalProduct from 'components/block-elements/additional-product/additional-product';

export default class Upsell extends Component {
  static propTypes = {
    upsellType: PropTypes.oneOf(["UPGRADE_PRODUCT", "ADDITIONAL_PRODUCT"]).isRequired,
    additionalProducts: PropTypes.array,
    upgradeInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.additionalProducts = extract(props, "additionalProducts");
    this.upsellType = extract(props, "upsellType");
    this.upgradeInfo = extract(props, "upgradeInfo");
  }

  render() {
    return this.upsellType === "UPGRADE_PRODUCT" ? (
      <UpgradeProduct info={this.upgradeInfo} />
    ) : (
      <div>Additional product</div>
    );
  }
}
